//cspell:disable
import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Useletter from './Useletter';
import Foter from './Foter';

function Men() {
  return (
    <div>
       <Container>
      <Row>
        <Col xs={12} md={6}>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/01_10.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'

        }}/>
        </Col>
        <Col xs={12} md={6}>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/02_8.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'
        }}/>
        </Col>
      </Row>
      </Container>
      <Container>
      <Row>
        <Col xs={12} md={4}><img src="https://www.junaidjamshed.com/media/wysiwyg/fabric.jpg" style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'
        }} alt="" /></Col>
        <Col xs={12} md={4}><img src="https://www.junaidjamshed.com/media/wysiwyg/footwear_20.jpg" alt=""
        style={{
          width:'100%',
          height:'auto',
          objectFit:'cover',
           marginTop: '90px'
      }} /></Col>
        <Col xs={12} md={4}><img src="https://www.junaidjamshed.com/media/wysiwyg/cap_1.jpg" alt="" 
        style={{
          width:'100%',
          height:'auto',
          objectFit:'cover',
           marginTop: '90px'
      }}/></Col>
      </Row>
    </Container>


    <p>AROMATICS <hr /></p>
    <Container>
      <Row>
        <Col xs={12} sm={6} md={4} lg={3}>
        <div className="box-content">
        <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/a/janan_oud_1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   }} /> </div>
   <br /><br />
   <div className="hiding"><p>JANAN OUD 
   </p>
   </div>
   <div className="d2">
   <i class="fa-solid fa-star"></i>
   <i class="fa-solid fa-star"></i>
   <i class="fa-solid fa-star"></i>
   <i class="fa-solid fa-star"></i>
   <i class="fa-solid fa-star"></i>
   </div>
   <b>PKR 2,590.00</b>
   <div id="d1" style={{fontSize:'12px'}}>100</div>

   {/* <br ></br> */}

   <button className='bag'> ADD TO BAG</button>
   </div>
   
        </Col>
        <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/k/h/khumaar1_2_1_1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
    alt=''style={{height:'250px', width:'100%'
   }} /></div>
    <br /><br />
   <div className="hiding"><p>BROWN 
   </p>
   </div>
   <div className="d2">
   <i class="fa-solid fa-star"></i>
   <i class="fa-solid fa-star"></i>
   <i class="fa-solid fa-star"></i>
   <i class="fa-solid fa-star"></i>
   <i class="fa-solid fa-star"></i>
   </div>
   <b>PKR 2,590.00</b>
   <div id="d1" style={{fontSize:'12px'}}>100</div>
    {/* <br></br> */}
   <button className='bag'> ADD TO BAG</button>
</div></Col>
        <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/z/a/zarar_gold_1__1_1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
    <div className="hiding"><p>BROWN 
   </p>
   </div>
   <div className="d2">
   <i class="fa-solid fa-star"></i>
   <i class="fa-solid fa-star"></i>
   <i class="fa-solid fa-star"></i>
   <i class="fa-solid fa-star"></i>
   <i class="fa-solid fa-star"></i>
   </div>
   <b>PKR 2,590.00</b>
   <div id="d1" style={{fontSize:'12px'}}>100</div>
  {/* <br></br> */}
   <button className='bag'> ADD TO BAG</button>
</div></Col>
        <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/z/a/zarar_bleu_1__1_1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
    <div className="hiding"><p>BROWN 
   </p>
   </div>
   <div className="d2">
   <i class="fa-solid fa-star"></i>
   <i class="fa-solid fa-star"></i>
   <i class="fa-solid fa-star"></i>
   <i class="fa-solid fa-star"></i>
   <i class="fa-solid fa-star"></i>
   </div>
   <b>PKR 2,590.00</b>
   <div id="d1" style={{fontSize:'12px'}}>100</div>
   
    {/* <br></br> */}
   <button className='bag'> ADD TO BAG</button>
</div></Col>
        
      </Row>
    </Container>
    <p>MEN'S TRADITIONAL <hr /></p>



    <Container>
      <Row>
        <Col xs={12} sm={6} md={4} lg={3}>
        <div className="box-content">
        <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/j/jjk-sp-inr-a-45512_1__1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
           alt=''style={{height:'250px', width:'100%' }} /> </div>
   <br /><br />
   <div className="hiding"><p>BROWN CAMBRIC PRINTED <br/>
   <b>PKR 2,590.00</b>
   </p>
   </div>
   <div className="d">
   <div id="d1">XS</div>
   <div id="d1">S</div> 
   <div id="d1">M</div>
    <div id="d1">L</div>
     <div id="d1">XL</div>
   </div> 
   <br></br>
   <button className='bag'> ADD TO BAG</button>
   </div>
   
        </Col>
        <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/j/jjk-33142_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>BROWN CAMBRIC PRINTED <br/>
   <b>PKR 2,590.00</b>
   </p>
   </div>
   <div className="d">
   <div id="d1">XS</div>
   <div id="d1">S</div> 
   <div id="d1">M</div>
    <div id="d1">L</div>
     <div id="d1">XL</div>
   </div> <br></br>
   <button className='bag'> ADD TO BAG</button>
</div></Col>
        <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/j/jjk-sp-inr-a-45516_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>YELLOW CAMBRIC PRINTED 

 <br />
   <b>PKR 2,590.00</b>
   </p>
   </div>
   <div className="d">
   <div id="d1">XS</div>
   <div id="d1">S</div> 
   <div id="d1">M</div>
    <div id="d1">L</div>
     <div id="d1">XL</div>
   </div> <br></br>
   <button className='bag'> ADD TO BAG</button>
</div></Col>
        <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/j/jjk-47317_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>BROWN CAMBRIC PRINTED  <br />
   <b>PKR 2,590.00</b>
   </p>
   </div>
   <div className="d">
   <div id="d1">XS</div>
   <div id="d1">S</div> 
   <div id="d1">M</div>
    <div id="d1">L</div>
     <div id="d1">XL</div>
   </div> <br></br>
   <button className='bag'> ADD TO BAG</button>
</div></Col>
      </Row>
    </Container>


    <Container>
      <Row>
        <Col xs={12} md={6}>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/03_2.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'

        }}/>
        </Col>
        <Col xs={12} md={6}>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/grooms_4.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'
        }}/>
        </Col>
      </Row>
      </Container>



      <p>CAPS<hr /></p>



<Container>
  <Row>
    <Col xs={12} sm={6} md={4} lg={3}>
    <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/0/0/0045-r2_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
       alt=''style={{height:'250px', width:'100%' }} /> </div>
<br /><br />
<div className="hiding"><p>BROWN CAMBRIC PRINTED <br/>
<b>PKR 2,590.00</b>
</p>
</div>
<div className="d">
<div id="d1">XS</div>
<div id="d1">S</div> 
<div id="d1">M</div>
<div id="d1">L</div>
 <div id="d1">XL</div>
</div> 
<br></br>
<button className='bag'> ADD TO BAG</button>
</div>

    </Col>
    <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/0/0/0030-r10_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
 alt=''style={{height:'250px', width:'100%'
}} /></div>
<br /><br />
<div className="hiding"><p>BROWN CAMBRIC PRINTED <br/>
<b>PKR 2,590.00</b>
</p>
</div>
<div className="d">
<div id="d1">XS</div>
<div id="d1">S</div> 
<div id="d1">M</div>
<div id="d1">L</div>
 <div id="d1">XL</div>
</div> <br></br>
<button className='bag'> ADD TO BAG</button>
</div></Col>
    <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/0/0/0018-r66_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
 alt=''style={{height:'250px', width:'100%'

}} /></div>
<br /><br />
<div className="hiding"><p>YELLOW CAMBRIC PRINTED 

<br />
<b>PKR 2,590.00</b>
</p>
</div>
<div className="d">
<div id="d1">XS</div>
<div id="d1">S</div> 
<div id="d1">M</div>
<div id="d1">L</div>
 <div id="d1">XL</div>
</div> <br></br>
<button className='bag'> ADD TO BAG</button>
</div></Col>
    <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/_/j/_jj-cap-0002-r111_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className="hiding"><p>BROWN CAMBRIC PRINTED  <br />
<b>PKR 2,590.00</b>
</p>
</div>
<div className="d">
<div id="d1">XS</div>
<div id="d1">S</div> 
<div id="d1">M</div>
<div id="d1">L</div>
 <div id="d1">XL</div>
</div> <br></br>
<button className='bag'> ADD TO BAG</button>
</div></Col>
  </Row>
</Container>


<Container>
      <Row>
        <Col>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/black_musk.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'

        }}/>
        </Col>
        
      </Row>
      </Container>
       <Useletter/>
       <Foter/>

    </div>
  )
}

export default Men
